module.exports = require("prismjs/components/prism-ruby.js");